import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;

export const createContact = createAsyncThunk(
  "contacts/createContact",
  async (data, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/contacts/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage =
          responseDataError.error || "Ошибка при добавлении контакта";
        toast.error(errorMessage);
        return rejectWithValue(errorMessage);
      }

      const responseData = await response.json();
      toast.success("Контакт добавлен");
      return responseData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getContacts = createAsyncThunk(
  "contacts/getContacts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/contacts/`, {
        method: "GET",
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage =
          responseDataError.error || "Ошибка при загрузке контактов";
        toast.error(errorMessage);
        return rejectWithValue(errorMessage);
      }
      const responseData = response.json();
      return await responseData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const updateContacts = createAsyncThunk(
  "contacts/updateContacts",
  async (data, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/contacts/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage =
          responseDataError.error || "Ошибка при добавлении агента";
        toast.error(errorMessage);
        return rejectWithValue(errorMessage);
      }

      const responseData = await response.json();
      toast.success("Контакт обновлен");
      return responseData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const contactsSlice = createSlice({
  name: "contacts",
  initialState: {
    contacts: {},
    status: null,
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContacts.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getContacts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.contacts = action.payload;
      })
      .addCase(getContacts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createContact.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createContact.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.contacts = action.payload;
      })
      .addCase(createContact.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateContacts.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateContacts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.contacts = action.payload;
      })
      .addCase(updateContacts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default contactsSlice.reducer;
